var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 79,
    height: 79,
    viewBox: "0 0 79 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-park:upload-picture"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M72.4173 39.4997C72.4173 37.6817 70.9436 36.208 69.1257 36.208C67.3077 36.208 65.834 37.6817 65.834 39.4997H72.4173ZM39.5007 13.1663C41.3186 13.1663 42.7923 11.6926 42.7923 9.87467C42.7923 8.05674 41.3186 6.58301 39.5007 6.58301V13.1663ZM64.1882 65.833H14.8132V72.4163H64.1882V65.833ZM13.1673 64.1872V14.8122H6.58398V64.1872H13.1673ZM65.834 39.4997V64.1872H72.4173V39.4997H65.834ZM14.8132 13.1663H39.5007V6.58301H14.8132V13.1663ZM14.8132 65.833C13.9042 65.833 13.1673 65.0962 13.1673 64.1872H6.58398C6.58398 68.732 10.2683 72.4163 14.8132 72.4163V65.833ZM64.1882 72.4163C68.733 72.4163 72.4173 68.732 72.4173 64.1872H65.834C65.834 65.0962 65.0971 65.833 64.1882 65.833V72.4163ZM13.1673 14.8122C13.1673 13.9032 13.9042 13.1663 14.8132 13.1663V6.58301C10.2683 6.58301 6.58398 10.2673 6.58398 14.8122H13.1673Z",
    fill: "#C0C0C0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M9.87598 57.6031L27.475 41.4707C28.7025 40.3454 30.5771 40.3142 31.8414 41.3979L52.6676 59.249",
    stroke: "#C0C0C0",
    strokeWidth: 6.58333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M46.084 51.0206L53.9404 43.1642C55.0985 42.006 56.9323 41.8757 58.2429 42.8586L69.1256 51.0206",
    stroke: "#C0C0C0",
    strokeWidth: 6.58333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M60.8965 29.625V9.875",
    stroke: "#C0C0C0",
    strokeWidth: 6.58333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M52.667 18.1042L60.8962 9.875L69.1253 18.1042",
    stroke: "#C0C0C0",
    strokeWidth: 6.58333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.1efe35606601cae20542f4b0e041e5aa.svg";
export { ForwardRef as ReactComponent };